import { Component } from '@angular/core';
import { MsgMobilePreview } from '../../msg-interface/msg-mobile-preview';
import { TplPreviewData } from '../../msg-interface/data-model';
import { _MSGTYPES } from '../../shared/constant/msgType';

@Component({
  selector: 'icc-voice-mobile-preview',
  templateUrl: './voice-mobile-preview.component.html',
  styleUrls: ['./voice-mobile-preview.component.less'],
})
export class VoiceMobilePreviewComponent implements MsgMobilePreview {
  constructor() {}
  SCENE = 'icc-msg-mobile-preview';
  message: TplPreviewData;

  type: number = _MSGTYPES.MT.VOICE.type;

  setData(item: TplPreviewData): void {
    this.message = item;
  }

  clear(): void {
    // throw new Error('Method not implemented.');
  }
}
